import { createDecorator } from '../../instantiation/common/instantiation.js';
const IExtensionRecommendationNotificationService = ( createDecorator('IExtensionRecommendationNotificationService'));
export { IExtensionRecommendationNotificationService };
